import React, { useState, useEffect } from 'react';
import { supabase } from '../supabase';

const AdminApproval = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    setLoading(true);
    
    const { data, error } = await supabase
      .from('users')
      .select('id, email, role, approved')
      .eq('approved', false); // ✅ Fetch only unapproved users
  
    if (error) {
      setError(`Error fetching users: ${error.message}`);
    } else {
      setUsers(data);
    }
  
    setLoading(false);
  };
  

  const approveUser = async (userId) => {
    const { error } = await supabase
      .from('users')
      .update({ approved: true })
      .eq('id', userId); // ✅ Use `id` for accuracy

    if (error) {
      console.error('Error approving user:', error.message);
    } else {
      alert('User approved successfully!');
      setUsers(users.filter(user => user.id !== userId)); // ✅ Remove approved user instantly
    }
  };

  return (
    <div>
      <h3>Approve Users</h3>
      {error && <p style={{ color: "red" }}>{error}</p>}
      {loading ? (
        <p>Loading...</p>
      ) : users.length === 0 ? (
        <p>No users pending approval.</p>
      ) : (
        <table className="admin-table">
          <thead>
            <tr>
              <th>Email</th>
              <th>Role</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.id}>
                <td>{user.email}</td>
                <td>{user.role}</td>
                <td>
                  <button className="approve-button" onClick={() => approveUser(user.id)}>
                    Approve
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default AdminApproval;
